import { Box, Tooltip } from '@mui/material';
import { memo, useCallback, useEffect, useState } from 'react';
import { subscribeServices } from 'src/Services/ApiHandlers/subscribeService';
import { Storage } from 'src/Storage';
import { checkAdminRole, checkAuthorOrInstructorRole } from 'src/utils/checkRole';
import ChapterSummerize from '../ChapterSummerize/ChapterSummerize';
import AiChatPopup from './AiChatPopup';
import AiPresentationPopup from './Presentation/AiPresentationPopup';

const AiPopups = ({ summeryOpen, setSummeryOpen, book_id, slug, is_header, is_clone, is_header_two = false }) => {
  const hasToken = Storage.get('authToken');
  const hasRole = Storage.get('user-role') && JSON.parse(Storage.get('user-role'));
  const isLoggedIn = hasToken && hasRole;
  const userRole = isLoggedIn?.user_role;

  const [hasSubscribe, setHasSubscribe] = useState(false);

  const checkSubscribe = useCallback(async () => {
    try {
      const response = await subscribeServices.infoApi();
      return response;
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;
    checkSubscribe()
      .then((response) => {
        if (response.code === 200) {
          setHasSubscribe(response.data.allowAi);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [checkSubscribe, isLoggedIn]);

  const allowRole = checkAdminRole(userRole) || checkAuthorOrInstructorRole(userRole);
  const shouldShow = allowRole || hasSubscribe;

  if (!shouldShow) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '1rem',
        right: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        zIndex: '21',
      }}
    >
      <Tooltip title="Read AI-generated summaries" arrow>
        <Box>
          <ChapterSummerize
            open={summeryOpen}
            setOpen={setSummeryOpen}
            book_id={book_id}
            slug={slug}
            is_header={is_header}
            is_clone={is_clone}
            is_header_two={is_header_two}
          />
        </Box>
      </Tooltip>
      {allowRole && <AiPresentationPopup />}
      <AiChatPopup />
    </Box>
  );
};

export default memo(AiPopups);
